(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gilt-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.GiltWelcomePopup) return;

    var FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

    function root(el) {
      return el.closest ? el.closest('[data-gilt-welcome]') : null;
    }

    function storage() {
      try {
        var probe = '__gw__';
        window.localStorage.setItem(probe, '1');
        window.localStorage.removeItem(probe);
        return window.localStorage;
      } catch (e) {
        /* Private mode, or storage blocked. The popup still works, it just
           cannot remember that it has been seen. */
        return null;
      }
    }

    function suppressed(el) {
      var store = storage();
      if (!store) return false;
      var raw = store.getItem(el.dataset.storageKey);
      if (!raw) return false;
      var until = parseInt(raw, 10);
      if (isNaN(until)) return false;
      if (Date.now() > until) {
        store.removeItem(el.dataset.storageKey);
        return false;
      }
      return true;
    }

    function suppress(el, days) {
      var store = storage();
      if (!store) return;
      var span = parseFloat(days);
      if (isNaN(span) || span <= 0) span = 30;
      store.setItem(el.dataset.storageKey, String(Date.now() + span * 86400000));
    }

    /* ---------------- open / close ---------------- */

    function open(el) {
      if (el.dataset.open === 'true') return;
      el.dataset.open = 'true';
      el.hidden = false;
      el.previousFocus = document.activeElement;

      /* Reading offsetHeight forces the hidden state to land before the
         class flips, so the fade actually runs instead of being skipped. */
      void el.offsetHeight;
      el.classList.add('is-open');

      document.documentElement.style.overflow = 'hidden';
      var panel = el.querySelector('[data-gilt-welcome-panel]');
      if (panel) panel.focus();
    }

    function close(el, remember) {
      if (el.dataset.open !== 'true') return;
      el.dataset.open = 'false';
      el.classList.remove('is-open');
      document.documentElement.style.overflow = '';

      if (remember) suppress(el, el.dataset.rememberDays);

      window.setTimeout(function () {
        if (el.dataset.open !== 'true') el.hidden = true;
      }, 320);

      if (el.previousFocus && el.previousFocus.focus) el.previousFocus.focus();
    }

    function step(el, name) {
      var steps = el.querySelectorAll('[data-gilt-welcome-step]');
      Array.prototype.forEach.call(steps, function (s) {
        s.hidden = s.getAttribute('data-gilt-welcome-step') !== name;
      });
      el.setAttribute('data-step', name);
      var panel = el.querySelector('[data-gilt-welcome-panel]');
      if (panel) panel.focus();
    }

    /* ---------------- email ---------------- */

    /* The form posts itself, the browser's own way, so Shopify's bot
       protection travels with it. Everything here only watches the frame the
       reply lands in.

       One watcher, bound once and left in place, owns every outcome. An
       earlier version armed a fresh watcher per submission, which went wrong
       twice over: the audience step submitted the form and so ran the submit
       handler as well, giving two watchers that raced and undid each other's
       step; and a watcher that resolved on the challenge removed itself, so
       nothing was left listening when the shopper actually answered it. */

    function nextStep(el) {
      if (el.getAttribute('data-step') === 'email') {
        return el.dataset.hasSegment === 'true' ? 'segment' : 'code';
      }
      return 'code';
    }

    function busy(el, state) {
      var button = el.querySelector('[data-gilt-welcome-submit]');
      if (!button) return;
      if (state) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    }

    function showError(el) {
      var note = el.querySelector('[data-gilt-welcome-error]');
      if (!note) return;
      note.textContent = el.dataset.errorMessage || note.textContent;
      note.hidden = false;
    }

    /* A challenge cannot be answered in a frame nobody can see, so the frame
       is brought into view and the shopper finishes it in place. The watcher
       stays armed, because answering it loads the frame a second time. */
    function showChallenge(el) {
      el.classList.add('is-challenge');
      var note = el.querySelector('[data-gilt-welcome-error]');
      if (note && el.dataset.verifyMessage) {
        note.textContent = el.dataset.verifyMessage;
        note.hidden = false;
      }
    }

    function clearChallenge(el) {
      el.classList.remove('is-challenge');
      var note = el.querySelector('[data-gilt-welcome-error]');
      if (note) note.hidden = true;
    }

    function watchSink(el) {
      var frame = el.querySelector('[data-gilt-welcome-sink]');
      if (!frame || frame.dataset.bound === 'true') return;
      frame.dataset.bound = 'true';

      frame.addEventListener('load', function () {
        /* The frame's own empty first load is not an answer to anything. */
        if (el.dataset.awaiting !== 'true') return;

        var href = '';
        try { href = frame.contentWindow.location.href || ''; } catch (e) { href = ''; }

        if (href && /challenge|captcha/i.test(href)) {
          busy(el, false);
          return showChallenge(el);   /* still awaiting, deliberately */
        }

        el.dataset.awaiting = 'false';
        window.clearTimeout(el.replyTimer);
        busy(el, false);
        clearChallenge(el);
        step(el, nextStep(el));
      });
    }

    function beginPost(el) {
      el.dataset.awaiting = 'true';
      clearChallenge(el);
      busy(el, true);
      window.clearTimeout(el.replyTimer);
      el.replyTimer = window.setTimeout(function () {
        if (el.dataset.awaiting !== 'true') return;
        el.dataset.awaiting = 'false';
        busy(el, false);
        showError(el);
      }, 15000);
    }

    /* Carries the chosen audience into the tags before the form goes, so the
       answer rides the same kind of submission as the address. */
    function applySegment(el, value) {
      var fields = el.querySelectorAll('[data-gilt-welcome-tags]');
      Array.prototype.forEach.call(fields, function (field) {
        if (field.dataset.baseTags === undefined) field.dataset.baseTags = field.value;
        var base = field.dataset.baseTags;
        field.value = value ? (base ? base + ', ' + value : value) : base;
      });
    }

    /* ---------------- the code ---------------- */

    function copyCode(el) {
      var value = el.querySelector('[data-gilt-welcome-code-value]');
      var note = el.querySelector('[data-gilt-welcome-copied]');
      if (!value) return;
      var text = value.textContent.trim();

      function done() {
        if (!note) return;
        note.textContent = el.dataset.copiedLabel || 'Copied';
        note.hidden = false;
        window.clearTimeout(el.copyTimer);
        el.copyTimer = window.setTimeout(function () { note.hidden = true; }, 2400);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () { fallbackCopy(text, done); });
      } else {
        fallbackCopy(text, done);
      }
    }

    function fallbackCopy(text, done) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(field);
    }

    /* Same documented route the promo line uses: the code goes onto the cart
       with /cart/update.js, so it is already there at checkout. */
    function useCode(el, button) {
      var code = el.dataset.discountCode;
      var target = el.dataset.useUrl;

      function leave() {
        suppress(el, el.dataset.rememberDays);
        if (target) {
          window.location.href = target;
        } else {
          close(el, true);
        }
      }

      if (el.dataset.applyDiscount !== 'true' || !code) return leave();

      var rootUrl =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      button.setAttribute('aria-busy', 'true');

      fetch(rootUrl.replace(/\/$/, '') + '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code })
      })
        .catch(function () {})
        .then(function () {
          button.removeAttribute('aria-busy');
          leave();
        });
    }

    /* ---------------- wiring ---------------- */

    function trapFocus(el, event) {
      if (event.key !== 'Tab') return;
      var items = el.querySelectorAll(FOCUSABLE);
      var visible = Array.prototype.filter.call(items, function (i) {
        return i.offsetParent !== null;
      });
      if (!visible.length) return;
      var first = visible[0];
      var last = visible[visible.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function schedule(el) {
      var design = el.dataset.designMode === 'true';

      if (!design) {
        if (el.dataset.hideForCustomers === 'true' && el.dataset.isCustomer === 'true') return;
        if (suppressed(el)) return;
      }

      var fired = false;
      function fire() {
        if (fired) return;
        fired = true;
        open(el);
      }

      var delay = parseFloat(el.dataset.delay);
      if (isNaN(delay)) delay = 0;
      window.setTimeout(fire, design ? 120 : delay * 1000);

      var threshold = parseFloat(el.dataset.scroll);
      if (!isNaN(threshold) && threshold > 0) {
        var onScroll = function () {
          var height = document.documentElement.scrollHeight - window.innerHeight;
          if (height <= 0) return;
          if ((window.scrollY / height) * 100 >= threshold) {
            window.removeEventListener('scroll', onScroll);
            fire();
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    }

    function init(el) {
      if (!el || el.dataset.ready === 'true') return;
      el.dataset.ready = 'true';

      el.addEventListener('click', function (event) {
        var target = event.target;

        /* Dismiss and close do the same thing. They are separate hooks only
           because they are separate controls in the design. */
        if (target.closest('[data-gilt-welcome-close]') ||
            target.closest('[data-gilt-welcome-dismiss]')) {
          event.preventDefault();
          return close(el, true);
        }
        if (target.closest('[data-gilt-welcome-backdrop]')) return close(el, true);
        if (target.closest('[data-gilt-welcome-copy]')) {
          event.preventDefault();
          return copyCode(el);
        }

        var use = target.closest('[data-gilt-welcome-use]');
        if (use) {
          event.preventDefault();
          return useCode(el, use);
        }

        var option = target.closest('[data-gilt-welcome-option]');
        if (option) {
          event.preventDefault();
          applySegment(el, option.getAttribute('data-value') || '');
          var form = el.querySelector('.gilt-welcome__form');
          if (!form) return step(el, 'code');
          /* requestSubmit keeps it a real submission. It also fires the submit
             handler below, which is the single place that arms the watcher. */
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
          return;
        }
      });

      el.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') return close(el, true);
        trapFocus(el, event);
      });

      watchSink(el);
      schedule(el);
    }

    /* Caught on the document in the capture phase so one handler serves every
       instance however the markup got there.

       The valid path is deliberately NOT prevented. The browser is left to
       submit the form itself, which is the only way Shopify's bot protection
       rides along; the form's target keeps the reply out of the page. */
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('.gilt-welcome__form')) return;
      var el = root(form);
      if (!el) return;

      if (!form.checkValidity()) {
        event.preventDefault();
        return form.reportValidity();
      }

      beginPost(el);
    }, true);

    window.GiltWelcomePopup = { init: init, open: open, close: close, step: step };

    function boot() {
      var all = document.querySelectorAll('[data-gilt-welcome]');
      Array.prototype.forEach.call(all, init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function () {
      window.setTimeout(boot, 60);
    });

    document.addEventListener('shopify:section:select', function (event) {
      var el = event.target.querySelector
        ? event.target.querySelector('[data-gilt-welcome]')
        : null;
      if (el) open(el);
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      var el = event.target.querySelector
        ? event.target.querySelector('[data-gilt-welcome]')
        : null;
      if (el) close(el, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
